module.exports = __webpack_public_path__ + "img/MDI-pdf-disabled.8a661ef5.svg";